import axios from 'axios';
import { Observable, Subscriber } from 'rxjs';
import { PRE_AUTHORIZATION_TOKEN } from 'src/configs/APISchemas/PreAuthorizationToken';
import { GraphQLRequest } from 'src/helpers/GraphQLRequest';

const DomUtils = {
  getEl: function getEl(selector: string): any {
    return window.document.querySelector(selector);
  },
  hasClass: function hasClass(el: HTMLElement, cssClass: string) {
    if (el.classList) {
      return el.classList.contains(cssClass);
    }

    return !!el.className.match(
      new RegExp('(\\s|^)'.concat(cssClass, '(\\s|$)')),
    );
  },
  removeClass: function removeClass(el: HTMLElement, cssClass: string) {
    if (el.classList) {
      el.classList.remove(cssClass);
    } else if (DomUtils.hasClass(el, cssClass)) {
      const reg = new RegExp('(\\s|^)'.concat(cssClass, '(\\s|$)'));
      el.className = el.className.replace(reg, ' ');
    }
  },
};

const SendButtonEmit = (disabled: boolean, loading: boolean) => {
  eventEmitter.emit('buttonState', {
    disabled,
    loading,
  });
};

const ValidateAndGetPreAuthToken = function (callback: any) {
  SendButtonEmit(true, true);
  const WIN: any = window;
  const query = PRE_AUTHORIZATION_TOKEN(WIN.authTokenData);
  GraphQLRequest(query)
    .then((response) => {
      const clientToken = response.preAuthorizationToken.preAuthorizationToken;
      const publicKeyBase64 =
        response.preAuthorizationToken.preAuthorizationPublicKey;
      callback({
        clientToken,
        publicKeyBase64,
      });
      eventEmitter.emit('onTokenSuccess', response);
    })
    .catch((err) => {
      // eslint-disable-next-line no-console
      console.error(err);
      SendButtonEmit(false, false);
      eventEmitter.emit('onError', err);
    });
};

const onCreate = function (paymentForm: any) {
  const onSuccess = (clientToken: string) => {
    SendButtonEmit(true, true);
    axios
      .get('https://paymentjs.cardpaysolutions.com/tokens/'.concat(clientToken))
      .then((data) => {
        eventEmitter.emit('onSuccess', data);
        SendButtonEmit(false, false);
      })
      .catch((error) => {
        paymentForm.reset();
        eventEmitter.emit('onError', error);
        SendButtonEmit(false, false);
      });
  };

  const onError = (error: any) => {
    SendButtonEmit(false, false);
    paymentForm.reset();
    eventEmitter.emit('onError', error);
  };

  const form = DomUtils.getEl('#add-cc-form');
  if (form) {
    form.addEventListener('submit', function (e: any) {
      e.preventDefault();
      let hasError = false;
      let errorField = '';
      const ccFields = window.document.getElementsByClassName('payment-fields');
      for (let i = 0; i < ccFields.length; i++) {
        hasError =
          hasError || DomUtils.hasClass(ccFields[i] as HTMLElement, 'empty');
        hasError =
          hasError || DomUtils.hasClass(ccFields[i] as HTMLElement, 'invalid');
        if (hasError) {
          errorField = ccFields[i].id;
          break;
        }
      }
      if (!hasError) {
        SendButtonEmit(false, false);
        paymentForm.onSubmit(onSuccess, onError);
      }
      if (errorField) {
        eventEmitter.emit('inCompleteField', errorField);
      }
    });
    SendButtonEmit(false, false);
  }
};
let subscriber: Subscriber<any>;
const subject = new Observable((sub: Subscriber<any>) => {
  subscriber = sub;
});

const eventEmitter = {
  subscribe: subject.subscribe,
  emit: (type: string, data: any) => {
    subscriber.next({
      type,
      data,
    });
  },
};

export const Payeezy = {
  hooks: {
    preFlowHook: ValidateAndGetPreAuthToken,
  },
  onCreate,
  event: subject,
};
